/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { PaginatedResponse } from '@arpeggi/shared'
import axios from 'axios'
import User from '../types/models/User'

const useProfileAPI = () => {
  // Genesis

  const getWalletFavoritedGenesisSongs = async (wallet_address: string) => {
    const resp = await axios.get(`/api/v1/wallet/${wallet_address}/genesis-favorites`)
    return resp.data
  }

  // Read

  const getWalletFavoritedSongs = async (wallet_address: string) => {
    const resp = await axios.get(`/api/v1/favorites`, {
      params: {
        type: 'song',
        wallet_address
      }
    })
    return resp.data
  }

  const getWalletFavoritedGenesisAndV2Songs = async (wallet_address: string) => {
    const promises = [
      getWalletFavoritedGenesisSongs(wallet_address),
      getWalletFavoritedSongs(wallet_address)
    ]
    const resolvedPromises = await Promise.all(promises)

    return { songs: [...resolvedPromises[0].data, ...resolvedPromises[1].songs] }
  }

  ///////////////////// User Metrics /////////////////////////////////////

  // TODO we should rely on server validation for this, asking for a race condition
  const getIsValidDisplayName = async (displayName: string) => {
    const { data } = await axios.get<PaginatedResponse<User>>(`/api/v2/users`, {
      params: { displayName }
    })

    return data.meta.total === 0
  }

  return {
    getWalletFavoritedGenesisAndV2Songs,
    getWalletFavoritedGenesisSongs,
    getWalletFavoritedSongs,
    getIsValidDisplayName
  }
}

export default useProfileAPI
